import { useRoutes } from 'react-router-dom';

// routes
import HomePageRoutes from './HomePageRoutes';
import GuidanceToolRoutes from './GuidanceToolRoutes';
import MainRoutes from './MainRoutes';
import LoginRoutes from './LoginRoutes';
import PageNotFoundRoutes from './PageNotFoundRoute';

// ==============================|| ROUTING RENDER ||============================== //

export default function ThemeRoutes() {
    return useRoutes([HomePageRoutes, GuidanceToolRoutes, MainRoutes, LoginRoutes, PageNotFoundRoutes]);
}
